import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'
import { I18nService, LgType } from '../../../services/prod/i18n.service'

@Component({
  selector: 'bmcore-no-matching-search',
  templateUrl: './bmcore-no-matching-search.component.html',
  styleUrls: ['./bmcore-no-matching-search.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreNoMatchingSearchComponent implements OnInit {
  lg: LgType

  constructor(private i18nService: I18nService) {}

  ngOnInit(): void {
    this.lg = this.i18nService.getLanguageForPage()
  }
}
